import { render, staticRenderFns } from "./TransporterRFQList.vue?vue&type=template&id=3299fbc7"
import script from "./TransporterRFQList.vue?vue&type=script&lang=js"
export * from "./TransporterRFQList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports